import React from 'react';
import solarImage from '../assets/images/hero/solar-panels.jpg';
import electricianImage from '../assets/images/hero/villanyszerelo.jpg';
import climateImage from '../assets/images/klima.png';
import designImage from '../assets/images/vill_terv.png';
import equipmentImage from '../assets/images/berendezes.png';

const Content: React.FC = () => {
  const services = [
    {
      title: "Napelem rendszer telepítés",
      description: "Napelem rendszer teljes kivitelezéssel, tervezéstől a kivitelezésig. Környezetbarát energiatermelés otthonába.",
      image: solarImage,
      features: ["Ingyenes helyszíni felmérés", "5 év garancia", "Állami támogatás ügyintézés"],
      icon: "☀️"
    },
    {
      title: "Villanyszerelés",
      description: "Ingyenes villanyszerelési helyszíni felmérés, teljes körű villanyszerelési szolgáltatások minden igényre.",
      image: electricianImage,
      features: ["Biztonságos villanyszerelés", "Kamera és Riasztórendszer szerelés", "24/7 hibaelhárítás", "Regisztrált villanyszerelő", "Minőségi alkatrészek"],
      icon: "⚡"
    },
    {
      title: "Klíma telepítés és tisztítás",
      description: "Professzionális klíma telepítés és karbantartás. Hűvös nyarak garantáltan!",
      image: climateImage,
      features: ["Gyors és szakszerű telepítés", "Tisztítás és karbantartás", "Energiatakarékos megoldások (H TARIFA Igénylés)", "Szerviz szolgáltatás"],
      icon: "❄️"
    },
    {
      title: "Berendezés gyártás",
      description: "Egyedi villamos berendezések gyártása és fejlesztése. Testreszabott megoldások ipari és lakossági célokra.",
      image: equipmentImage,
      features: ["Egyedi tervezés", "Minőségi kivitelezés", "Teljes körű támogatás", "Garanciális szolgáltatás"],
      icon: "🔧"
    },
    {
      title: "Villamos tervezés",
      description: "Szakértő villamos tervezési szolgáltatások. Lakóépületektől az ipari létesítményekig.",
      image: designImage,
      features: ["Engedélyezési tervek", "Kivitelezési tervek", "Felülvizsgálatok", "Tanácsadás"],
      icon: "📐"
    }
  ];

  return (
    <>
      {/* Modern Services Section */}
      <section id="services" className="py-16 md:py-20 bg-white relative overflow-hidden">
        {/* Background decorative elements - only on larger screens */}
        <div className="hidden md:block absolute top-0 left-0 w-32 h-32 border border-red-600/10 rounded-full"></div>
        <div className="hidden md:block absolute bottom-0 right-0 w-40 h-40 border border-red-600/10 rounded-full"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4">
              <span className="text-red-600">P&K</span> Szolgáltatások
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4">
              Teljes körű villanyszerelési megoldások modern technológiával és szakértői tudással
            </p>
            <div className="w-24 h-1 bg-red-600 mx-auto mt-6"></div>
          </div>

          {/* First row - 3 services */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8 mb-8">
            {services.slice(0, 3).map((service, index) => (
              <div 
                key={index}
                className="group bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:scale-105 border border-red-600/10 hover:border-red-600/30"
              >
                {/* Service Image */}
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white/80 via-transparent to-transparent"></div>
                  <div className="absolute top-4 right-4 w-10 h-10 md:w-12 md:h-12 bg-red-600 rounded-full flex items-center justify-center text-xl md:text-2xl shadow-lg">
                    {service.icon}
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-4 md:p-6 bg-white">
                  <h3 className="text-xl md:text-2xl font-bold text-black mb-3 group-hover:text-red-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed text-sm md:text-base">
                    {service.description}
                  </p>
                  
                  {/* Features List */}
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-gray-700 text-sm md:text-base">
                        <span className="text-red-600 mr-2">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* CTA Button */}
                  <a 
                    href="#contact"
                    className="block w-full bg-white hover:bg-red-600 text-red-600 hover:text-white font-semibold py-3 px-4 md:px-6 rounded-lg transition-all duration-300 border-2 border-red-600 text-sm md:text-base group-hover:shadow-[0_0_20px_rgba(220,38,38,0.2)] text-center"
                  >
                    Ajánlatot kérek
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Second row - 2 services centered */}
          <div className="flex justify-center">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl">
              {services.slice(3, 5).map((service, index) => (
                <div 
                  key={index + 3}
                  className="group bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:scale-105 border border-red-600/10 hover:border-red-600/30"
                >
                  {/* Service Image */}
                  <div className="relative h-48 md:h-56 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-white/80 via-transparent to-transparent"></div>
                    <div className="absolute top-4 right-4 w-10 h-10 md:w-12 md:h-12 bg-red-600 rounded-full flex items-center justify-center text-xl md:text-2xl shadow-lg">
                      {service.icon}
                    </div>
                  </div>

                  {/* Service Content */}
                  <div className="p-4 md:p-6 bg-white">
                    <h3 className="text-xl md:text-2xl font-bold text-black mb-3 group-hover:text-red-600 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 mb-4 leading-relaxed text-sm md:text-base">
                      {service.description}
                    </p>
                    
                    {/* Features List */}
                    <ul className="space-y-2 mb-6">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center text-gray-700 text-sm md:text-base">
                          <span className="text-red-600 mr-2">✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    {/* CTA Button */}
                    <a 
                      href="#contact"
                      className="block w-full bg-white hover:bg-red-600 text-red-600 hover:text-white font-semibold py-3 px-4 md:px-6 rounded-lg transition-all duration-300 border-2 border-red-600 text-sm md:text-base group-hover:shadow-[0_0_20px_rgba(220,38,38,0.2)] text-center"
                    >
                      Ajánlatot kérek
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modern About Section */}
      <section id="about" className="py-16 md:py-20 bg-gradient-to-br from-white via-red-50 to-white relative">
        {/* Decorative background - only on larger screens */}
        <div className="absolute inset-0 opacity-10 hidden md:block">
          <div className="absolute top-20 left-10 w-2 h-32 bg-red-600"></div>
          <div className="absolute top-40 right-20 w-16 h-2 bg-red-600"></div>
          <div className="absolute bottom-20 left-1/3 w-8 h-8 border-2 border-red-600 rounded-full"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto">
            {/* Section Header */}
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4 md:mb-6">
                Miért válassza a <span className="text-red-600">P&K Electro</span>-t?
              </h2>
              <p className="text-lg md:text-xl text-gray-600 leading-relaxed px-4">
                A P&K Electro több éves szakmai tapasztalattal rendelkező villanyszerelési vállalkozás. 
                Célunk, hogy ügyfeleinknek minőségi, megbízható és hosszútávú megoldásokat kínáljunk.
              </p>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
              <div className="text-center bg-white shadow-lg p-6 rounded-2xl border border-red-600/10">
                <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">500+</div>
                <div className="text-black font-semibold mb-1">Elégedett Ügyfél</div>
                <div className="text-gray-600 text-sm">Sikeres projektek</div>
              </div>
              <div className="text-center bg-white shadow-lg p-6 rounded-2xl border border-red-600/10">
                <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">5+</div>
                <div className="text-black font-semibold mb-1">Év Tapasztalat</div>
                <div className="text-gray-600 text-sm">A piacon</div>
              </div>
              <div className="text-center bg-white shadow-lg p-6 rounded-2xl border border-red-600/10">
                <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">24/7</div>
                <div className="text-black font-semibold mb-1">Gyors Segítség</div>
                <div className="text-gray-600 text-sm">Hibaelhárítás</div>
              </div>
            </div>

            {/* Feature Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <div className="bg-white shadow-lg p-6 md:p-8 rounded-2xl border border-red-600/10 hover:border-red-600/30 transition-all duration-300">
                <div className="text-2xl md:text-3xl mb-4">🔧</div>
                <h3 className="text-xl md:text-2xl font-bold text-black mb-4">Szakértő Csapat</h3>
                <p className="text-gray-600 mb-4">
                  Csapatunk szakképzett villanyszerelőkből áll, akik mindig a legmagasabb színvonalon végzik munkájukat.
                </p>
                <div className="text-red-600 font-semibold">Referenciamunkáink megtekinthetők →</div>
              </div>
              
              <div className="bg-white shadow-lg p-6 md:p-8 rounded-2xl border border-red-600/10 hover:border-red-600/30 transition-all duration-300">
                <div className="text-2xl md:text-3xl mb-4">📞</div>
                <h3 className="text-xl md:text-2xl font-bold text-black mb-4">Gyors Elérhetőség</h3>
                <p className="text-gray-600 mb-4">
                  Keressen minket bizalommal! Ingyenes helyszíni felmérés és szaktanácsadás minden projekthez.
                </p>
                <div className="text-red-600 font-semibold">Hívjon most →</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modern Testimonials Section */}
      <section id="testimonials" className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4">
              Mit mondanak <span className="text-red-600">ügyfeleink?</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-600">Elégedett ügyfeleink véleménye a legfontosabb referenciánk</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {[
              {
                text: "Gyors, precíz munka, korrekt áron. A napelem rendszer telepítésével maximálisan elégedett vagyok. Professzionális hozzáállás minden téren!",
                name: "Kovács János",
                location: "Budapest",
                rating: 5,
                service: "Napelem telepítés"
              },
              {
                text: "Helyi cég, gyors kiszállás! A villamosbiztonsági felülvizsgálat alapos volt, minden dokumentumot rendben megkaptunk. Korrekt áron, időben!",
                name: "Tóth István",
                location: "Szolnok",
                rating: 5,
                service: "Villamosbiztonsági felülvizsgálat"
              },
              {
                text: "Kiváló munkát végeztek! A családi ház teljes villamosítását vállalták el, minden elvárásunkat felülmúlták. Tiszta, pontos munka!",
                name: "Horváth Andrea",
                location: "Budapest",
                rating: 5,
                service: "Villanyszerelés"
              }
            ].map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white shadow-lg p-6 md:p-8 rounded-2xl border border-red-600/10 hover:border-red-600/30 transition-all duration-300 hover:transform hover:-translate-y-2"
              >
                {/* Stars */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-lg md:text-xl">★</span>
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-gray-600 text-base md:text-lg leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </blockquote>

                {/* Client Info */}
                <div className="border-t border-red-600/10 pt-4">
                  <div className="font-bold text-black text-lg">{testimonial.name}</div>
                  <div className="text-gray-500 text-sm">{testimonial.location}</div>
                  <div className="text-red-600 text-sm font-semibold mt-1">{testimonial.service}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Content; 